import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Label,
  Tooltip,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Spinner,
  Alert,
} from "reactstrap";

//Simple bar
import SimpleBar from "simplebar-react";

import BreadCrumb from "../../../Components/Common/BreadCrumb";

import product1 from "../../../assets/images/products/img-1.png";
import product6 from "../../../assets/images/products/img-6.png";
import product8 from "../../../assets/images/products/img-8.png";

import { productDetailsWidgets, reviews } from "../../../common/data/ecommerce";

import { Swiper, SwiperSlide } from "swiper/react";
import classnames from "classnames";

// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";

import  { FreeMode, Navigation, Thumbs } from "swiper/modules";
import SwiperCore from "swiper";

import { Link, useParams, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getProducts as onGetProducts } from "../../../slices/thunks";
import { resolveProductImageSrc } from "../../../helpers/productImageUrl";

SwiperCore.use([FreeMode, Navigation, Thumbs]);

const ProductReview = (props) => {
  return (
    <React.Fragment>
      <li className="py-2">
        <div className="border border-dashed rounded p-3">
          <div className="d-flex align-items-start mb-3">
            <div className="hstack gap-3">
              <div className="badge rounded-pill bg-success mb-0">
                <i className="mdi mdi-star"></i> {props.review.rating}
              </div>
              <div className="vr"></div>
              <div className="flex-grow-1">
                <p className="text-muted mb-0">{props.review.comment}</p>
              </div>
            </div>
          </div>
          {props.review.subitem && (
            <React.Fragment>
              <div className="d-flex flex-grow-1 gap-2 mb-3">
                {props.review.subitem.map((subItem, key) => (
                  <React.Fragment key={key}>
                    <Link to="#" className="d-block">
                      <img
                        src={subItem.img}
                        alt=""
                        className="avatar-sm rounded object-fit-cover"
                      />
                    </Link>
                  </React.Fragment>
                ))}
              </div>
            </React.Fragment>
          )}

          <div className="d-flex align-items-end">
            <div className="flex-grow-1">
              <h5 className="fs-14 mb-0">{props.review.name}</h5>
            </div>

            <div className="flex-shrink-0">
              <p className="text-muted fs-13 mb-0">{props.review.date}</p>
            </div>
          </div>
        </div>
      </li>
    </React.Fragment>
  );
};

const PricingWidgetList = (props) => {
  return (
    <React.Fragment>
      <Col lg={3} sm={6}>
        <div className="p-2 border border-dashed rounded">
          <div className="d-flex align-items-center">
            <div className="avatar-sm me-2">
              <div className="avatar-title rounded bg-transparent text-success fs-24">
                <i className={props.pricingDetails.icon}></i>
              </div>
            </div>
            <div className="flex-grow-1">
              <p className="text-muted mb-1">{props.pricingDetails.label} :</p>
              <h5 className="mb-0">{props.pricingDetails.labelDetail}</h5>
            </div>
          </div>
        </div>
      </Col>
    </React.Fragment>
  );
};

function EcommerceProductDetail(props) {
  const { _id } = useParams(); // Get product ID from URL
  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  // Get products from Redux
  const productsRaw = useSelector((state) => state.Ecommerce?.products);
  const products = Array.isArray(productsRaw) ? productsRaw : [];
  
  // Find the current product
  const product = products.find(p => (p.id || p._id) == _id);
  
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const [ttop, setttop] = useState(false);
  const [loading, setLoading] = useState(!product); // Loading if product not found

  const [ssize, setssize] = useState(false);
  const [msize, setmsize] = useState(false);
  const [lsize, setlsize] = useState(false);
  const [xlsize, setxlsize] = useState(false);
  const [customActiveTab, setcustomActiveTab] = useState("1");
  const toggleCustom = tab => {
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab);
    }
  };

  // Fetch products if not loaded or product not found
  useEffect(() => {
    if (!product && _id) {
      dispatch(onGetProducts());
    }
  }, [dispatch, _id, product]);

  // Check again after products load
  useEffect(() => {
    if (products.length > 0 && !product && _id) {
      const foundProduct = products.find(p => (p.id || p._id) == _id);
      if (!foundProduct) {
        setLoading(false); // Product not found
      } else {
        setLoading(false);
      }
    } else if (product) {
      setLoading(false);
    }
  }, [products, _id, product]);

  // Parse gallery images
  const galleryImages = product?.images 
    ? (typeof product.images === 'string' ? JSON.parse(product.images) : product.images)
    : [];
  
  // Get image URLs (handles full URLs, /images/... paths, or bare filenames)
  const thumbField = product?.thumbnail || product?.image;
  const thumbnailUrl = thumbField ? resolveProductImageSrc(thumbField) : null;

  const galleryImageUrls = galleryImages.map((img) =>
    img ? resolveProductImageSrc(img) : null
  );

  // All images for slider (thumbnail + gallery)
  const allImages = thumbnailUrl
    ? [thumbnailUrl, ...galleryImageUrls].filter(Boolean)
    : galleryImageUrls.filter(Boolean);

  document.title = product ? `${product.name || 'Product Details'} | Topcoinland` : "Product Details | Topcoinland";

  // Loading state
  if (loading) {
    return (
      <div className="page-content">
        <Container fluid>
          <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
            <Spinner color="primary" />
          </div>
        </Container>
      </div>
    );
  }

  // Product not found
  if (!product) {
    return (
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Product Details" pageTitle="Ecommerce" />
          <Alert color="danger">
            Product not found. <Link to="/products">Go back to products list</Link>
          </Alert>
        </Container>
      </div>
    );
  }

  return (
    <div className="page-content">
      <Container fluid>        
        <BreadCrumb title="Product Details" pageTitle="Ecommerce" />

        <Row>
          <Col lg={12}>
            <Card>
              <CardBody>
                <Row className="gx-lg-5">
                  <Col xl={4} md={8} className="mx-auto">
                    <div className="product-img-slider sticky-side-div">
                      <Swiper
                        navigation={true}
                        thumbs={{ swiper: thumbsSwiper }}
                        className="swiper product-thumbnail-slider p-2 rounded bg-light"
                      >
                        <div className="swiper-wrapper">
                          {allImages.length > 0 ? (
                            allImages.map((imgUrl, index) => (
                              <SwiperSlide key={index}>
                                <img
                                  src={imgUrl}
                                  alt={product.name || 'Product image'}
                                  className="img-fluid d-block"
                                  onError={(e) => {
                                    e.target.src = "https://via.placeholder.com/400?text=No+Image";
                                  }}
                                />
                              </SwiperSlide>
                            ))
                          ) : (
                            <SwiperSlide>
                              <img
                                src="https://via.placeholder.com/400?text=No+Image"
                                alt="No image"
                                className="img-fluid d-block"
                              />
                            </SwiperSlide>
                          )}
                        </div>
                      </Swiper>

                      <div className="product-nav-slider mt-2">
                        <Swiper
                          onSwiper={setThumbsSwiper}
                          slidesPerView={4}
                          freeMode={true}
                          watchSlidesProgress={true}
                          spaceBetween={10}
                          className="swiper product-nav-slider mt-2 overflow-hidden"
                        >
                          <div className="swiper-wrapper">
                            {allImages.length > 0 ? (
                              allImages.map((imgUrl, index) => (
                                <SwiperSlide key={index} className="rounded">
                                  <div className="nav-slide-item">
                                    <img
                                      src={imgUrl}
                                      alt={`${product.name || 'Product'} thumbnail ${index + 1}`}
                                      className="img-fluid d-block rounded"
                                      onError={(e) => {
                                        e.target.src = "https://via.placeholder.com/100?text=No+Image";
                                      }}
                                    />
                                  </div>
                                </SwiperSlide>
                              ))
                            ) : (
                              <SwiperSlide className="rounded">
                                <div className="nav-slide-item">
                                  <img
                                    src="https://via.placeholder.com/100?text=No+Image"
                                    alt="No image"
                                    className="img-fluid d-block rounded"
                                  />
                                </div>
                              </SwiperSlide>
                            )}
                          </div>
                        </Swiper>
                      </div>
                    </div>
                  </Col>

                  <Col xl={8}>
                    <div className="mt-xl-0 mt-5">
                      <div className="d-flex">
                        <div className="flex-grow-1">
                          <h4>{product.name || 'Product Name'}</h4>
                          <div className="hstack gap-3 flex-wrap">
                            {product.categoryName && (
                              <>
                                <div>
                                  <span className="text-primary d-block">
                                    {product.categoryName}
                                    {product.subcategoryName && product.subcategoryName !== 'N/A' && ` / ${product.subcategoryName}`}
                                  </span>
                                </div>
                                <div className="vr"></div>
                              </>
                            )}
                            <div className="text-muted">
                              SKU :{" "}
                              <span className="text-body fw-medium">
                                {product.sku || product.stock || 'N/A'}
                              </span>
                            </div>
                            <div className="vr"></div>
                            <div className="text-muted">
                              Status :{" "}
                              <span className={`badge ${product.status === 'published' ? 'bg-success' : product.status === 'draft' ? 'bg-secondary' : 'bg-warning'}`}>
                                {product.status || 'draft'}
                              </span>
                            </div>
                            {product.created_at && (
                              <>
                                <div className="vr"></div>
                                <div className="text-muted">
                                  Created :{" "}
                                  <span className="text-body fw-medium">
                                    {new Date(product.created_at).toLocaleDateString()}
                                  </span>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                        <div className="flex-shrink-0">
                          <div>
                            <Tooltip
                              placement="top"
                              isOpen={ttop}
                              target="TooltipTop"
                              toggle={() => {
                                setttop(!ttop);
                              }}
                            >
                              Edit
                            </Tooltip>
                            <Link
                              to={`/products`}
                              id="TooltipTop"
                              className="btn btn-light me-2"
                              onClick={(e) => {
                                e.preventDefault();
                                navigate(`/products`);
                                // Trigger edit modal from products page
                                window.location.hash = `edit-${product.id || product._id}`;
                              }}
                            >
                              <i className="ri-pencil-fill align-bottom"></i>
                            </Link>
                            <Link
                              to="/products"
                              className="btn btn-secondary"
                            >
                              <i className="ri-arrow-left-line align-bottom"></i> Back
                            </Link>
                          </div>
                        </div>
                      </div>

                      <div className="d-flex flex-wrap gap-2 align-items-center mt-3">
                        <h3 className="text-primary mb-0">
                          £{product.price ? parseFloat(product.price).toFixed(2) : '0.00'}
                          {product.product_discount && (
                            <span className="text-muted text-decoration-line-through ms-2 fs-14">
                              £{(parseFloat(product.price) / (1 - parseFloat(product.product_discount) / 100)).toFixed(2)}
                            </span>
                          )}
                        </h3>
                        {product.product_discount && (
                          <span className="badge bg-danger ms-2">
                            {product.product_discount}% OFF
                          </span>
                        )}
                      </div>

                      <Row className="mt-4">
                        <Col sm={3}>
                          <div className="p-3 border border-dashed rounded">
                            <div className="d-flex align-items-center">
                              <div className="flex-shrink-0 avatar-sm">
                                <div className="avatar-title bg-light text-primary rounded fs-20">
                                  <i className="ri-money-pound-circle-fill"></i>
                                </div>
                              </div>
                              <div className="flex-grow-1 ms-3">
                                <p className="text-muted mb-1">Price</p>
                                <h5 className="mb-0">£{product.price ? parseFloat(product.price).toFixed(2) : '0.00'}</h5>
                              </div>
                            </div>
                          </div>
                        </Col>
                        <Col sm={3}>
                          <div className="p-3 border border-dashed rounded">
                            <div className="d-flex align-items-center">
                              <div className="flex-shrink-0 avatar-sm">
                                <div className="avatar-title bg-light text-success rounded fs-20">
                                  <i className="ri-stack-line"></i>
                                </div>
                              </div>
                              <div className="flex-grow-1 ms-3">
                                <p className="text-muted mb-1">Stock</p>
                                <h5 className="mb-0">{product.stock_quantity !== undefined ? product.stock_quantity : (product.stock || 'N/A')}</h5>
                              </div>
                            </div>
                          </div>
                        </Col>
                        <Col sm={3}>
                          <div className="p-3 border border-dashed rounded">
                            <div className="d-flex align-items-center">
                              <div className="flex-shrink-0 avatar-sm">
                                <div className="avatar-title bg-light text-info rounded fs-20">
                                  <i className="ri-barcode-line"></i>
                                </div>
                              </div>
                              <div className="flex-grow-1 ms-3">
                                <p className="text-muted mb-1">SKU</p>
                                <h5 className="mb-0">{product.sku || product.stock || 'N/A'}</h5>
                              </div>
                            </div>
                          </div>
                        </Col>
                        <Col sm={3}>
                          <div className="p-3 border border-dashed rounded">
                            <div className="d-flex align-items-center">
                              <div className="flex-shrink-0 avatar-sm">
                                <div className="avatar-title bg-light text-warning rounded fs-20">
                                  <i className="ri-eye-line"></i>
                                </div>
                              </div>
                              <div className="flex-grow-1 ms-3">
                                <p className="text-muted mb-1">Visibility</p>
                                <h5 className="mb-0">{product.visibility || 'Public'}</h5>
                              </div>
                            </div>
                          </div>
                        </Col>
                      </Row>

                      {/* Product Description */}
                      {product.short_description && (
                        <div className="mt-4">
                          <h5 className="fs-16 mb-3">Short Description</h5>
                          <p className="text-muted">{product.short_description}</p>
                        </div>
                      )}

                      {product.description && (
                        <div className="mt-4">
                          <h5 className="fs-16 mb-3">Description</h5>
                          <div 
                            className="text-muted"
                            dangerouslySetInnerHTML={{ __html: product.description }}
                          />
                        </div>
                      )}

                      {/* Hide sizes section as it's not part of our product model */}
                      {false && (
                      <Row>
                        <Col xl={6}>
                          <div className=" mt-4">
                            <h5 className="fs-14">Sizes :</h5>
                            <div className="d-flex flex-wrap gap-2">
                              <Tooltip
                                placement="top"
                                isOpen={ssize}
                                target="TooltipSSize"
                                toggle={() => {
                                  setssize(!ssize);
                                }}
                              >
                                Out of Stock
                              </Tooltip>
                              <Tooltip
                                placement="top"
                                isOpen={msize}
                                target="TooltipMSize"
                                toggle={() => {
                                  setmsize(!msize);
                                }}
                              >
                                04 Items Available
                              </Tooltip>
                              <Tooltip
                                placement="top"
                                isOpen={lsize}
                                target="TooltipLSize"
                                toggle={() => {
                                  setlsize(!lsize);
                                }}
                              >
                                06 Items Available
                              </Tooltip>
                              <Tooltip
                                placement="top"
                                isOpen={xlsize}
                                target="TooltipXlSize"
                                toggle={() => {
                                  setxlsize(!xlsize);
                                }}
                              >
                                Out of Stock
                              </Tooltip>

                              <Input
                                type="radio"
                                className="btn-check"
                                name="productsize-radio"
                              />
                              <Label
                                className="btn btn-soft-primary avatar-xs rounded-circle p-0 d-flex justify-content-center align-items-center"
                                id="TooltipSSize"
                              >
                                S
                              </Label>

                              <Input
                                type="radio"
                                className="btn-check"
                                name="productsize-radio"
                              />
                              <Label
                                className="btn btn-soft-primary avatar-xs rounded-circle p-0 d-flex justify-content-center align-items-center"
                                id="TooltipMSize"
                              >
                                M
                              </Label>

                              <Input
                                type="radio"
                                className="btn-check"
                                name="productsize-radio"
                              />
                              <Label
                                className="btn btn-soft-primary avatar-xs rounded-circle p-0 d-flex justify-content-center align-items-center"
                                id="TooltipLSize"
                              >
                                L
                              </Label>

                              <Input
                                type="radio"
                                className="btn-check"
                                name="productsize-radio"
                              />
                              <Label
                                className="btn btn-soft-primary avatar-xs rounded-circle p-0 d-flex justify-content-center align-items-center"
                                id="TooltipXlSize"
                              >
                                XL
                              </Label>
                            </div>
                          </div>
                        </Col>

                        <Col xl={6}>
                          <div className=" mt-4">
                            <h5 className="fs-14">Colors :</h5>
                            <div className="d-flex flex-wrap gap-2">
                              <div
                                data-bs-toggle="tooltip"
                                data-bs-trigger="hover"
                                data-bs-placement="top"
                                title="Out of Stock"
                              >
                                <button
                                  type="button"
                                  className="btn avatar-xs p-0 d-flex align-items-center justify-content-center border rounded-circle fs-20 text-primary"
                                  disabled
                                >
                                  <i className="ri-checkbox-blank-circle-fill"></i>
                                </button>
                              </div>
                              <div
                                data-bs-toggle="tooltip"
                                data-bs-trigger="hover"
                                data-bs-placement="top"
                                title="03 Items Available"
                              >
                                <button
                                  type="button"
                                  className="btn avatar-xs p-0 d-flex align-items-center justify-content-center border rounded-circle fs-20 text-secondary"
                                >
                                  <i className="ri-checkbox-blank-circle-fill"></i>
                                </button>
                              </div>
                              <div
                                data-bs-toggle="tooltip"
                                data-bs-trigger="hover"
                                data-bs-placement="top"
                                title="03 Items Available"
                              >
                                <button
                                  type="button"
                                  className="btn avatar-xs p-0 d-flex align-items-center justify-content-center border rounded-circle fs-20 text-success"
                                >
                                  <i className="ri-checkbox-blank-circle-fill"></i>
                                </button>
                              </div>
                              <div
                                data-bs-toggle="tooltip"
                                data-bs-trigger="hover"
                                data-bs-placement="top"
                                title="02 Items Available"
                              >
                                <button
                                  type="button"
                                  className="btn avatar-xs p-0 d-flex align-items-center justify-content-center border rounded-circle fs-20 text-info"
                                >
                                  <i className="ri-checkbox-blank-circle-fill"></i>
                                </button>
                              </div>
                              <div
                                data-bs-toggle="tooltip"
                                data-bs-trigger="hover"
                                data-bs-placement="top"
                                title="01 Items Available"
                              >
                                <button
                                  type="button"
                                  className="btn avatar-xs p-0 d-flex align-items-center justify-content-center border rounded-circle fs-20 text-warning"
                                >
                                  <i className="ri-checkbox-blank-circle-fill"></i>
                                </button>
                              </div>
                              <div
                                data-bs-toggle="tooltip"
                                data-bs-trigger="hover"
                                data-bs-placement="top"
                                title="04 Items Available"
                              >
                                <button
                                  type="button"
                                  className="btn avatar-xs p-0 d-flex align-items-center justify-content-center border rounded-circle fs-20 text-danger"
                                >
                                  <i className="ri-checkbox-blank-circle-fill"></i>
                                </button>
                              </div>
                              <div
                                data-bs-toggle="tooltip"
                                data-bs-trigger="hover"
                                data-bs-placement="top"
                                title="03 Items Available"
                              >
                                <button
                                  type="button"
                                  className="btn avatar-xs p-0 d-flex align-items-center justify-content-center border rounded-circle fs-20 text-light"
                                >
                                  <i className="ri-checkbox-blank-circle-fill"></i>
                                </button>
                              </div>
                              <div
                                data-bs-toggle="tooltip"
                                data-bs-trigger="hover"
                                data-bs-placement="top"
                                title="04 Items Available"
                              >
                                <button
                                  type="button"
                                  className="btn avatar-xs p-0 d-flex align-items-center justify-content-center border rounded-circle fs-20 text-body"
                                >
                                  <i className="ri-checkbox-blank-circle-fill"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </Col>
                      </Row>
                      )}

                      <Row>
                        <Col sm={6}>
                          <div className="mt-3">
                            <h5 className="fs-14">Features :</h5>
                            <ul className="list-unstyled">
                              <li className="py-1">
                                <i className="mdi mdi-circle-medium me-1 text-muted align-middle"></i>{" "}
                                Full Sleeve
                              </li>
                              <li className="py-1">
                                <i className="mdi mdi-circle-medium me-1 text-muted align-middle"></i>{" "}
                                Cotton
                              </li>
                              <li className="py-1">
                                <i className="mdi mdi-circle-medium me-1 text-muted align-middle"></i>{" "}
                                All Sizes available
                              </li>
                              <li className="py-1">
                                <i className="mdi mdi-circle-medium me-1 text-muted align-middle"></i>{" "}
                                4 Different Color
                              </li>
                            </ul>
                          </div>
                        </Col>
                        <Col sm={6}>
                          <div className="mt-3">
                            <h5 className="fs-14">Services :</h5>
                            <ul className="list-unstyled product-desc-list">
                              <li className="py-1">10 Days Replacement</li>
                              <li className="py-1">
                                Cash on Delivery available
                              </li>
                            </ul>
                          </div>
                        </Col>
                      </Row>

                      <div className="product-content mt-5">
                        <h5 className="fs-14 mb-3">Product Description :</h5>
                        <Nav tabs className="nav-tabs-custom nav-success">
                          <NavItem>
                            <NavLink
                              style={{ cursor: "pointer" }}
                              className={classnames({
                                active: customActiveTab === "1",
                              })}
                              onClick={() => {
                                toggleCustom("1");
                              }}
                            >
                              Specification
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              style={{ cursor: "pointer" }}
                              className={classnames({
                                active: customActiveTab === "2",
                              })}
                              onClick={() => {
                                toggleCustom("2");
                              }}
                            >
                              Details
                            </NavLink>
                          </NavItem>
                        </Nav>

                        <TabContent
                        activeTab={customActiveTab}
                          className="border border-top-0 p-4"
                          id="nav-tabContent"
                        >
                          <TabPane
                            id="nav-speci"
                            tabId="1"
                          >
                            <div className="table-responsive">
                              <table className="table mb-0">
                                <tbody>
                                  <tr>
                                    <th scope="row" style={{ width: "200px" }}>
                                      Category
                                    </th>
                                    <td>{product.categoryName || 'N/A'}</td>
                                  </tr>
                                  {product.subcategoryName && product.subcategoryName !== 'N/A' && (
                                  <tr>
                                    <th scope="row">Subcategory</th>
                                    <td>{product.subcategoryName}</td>
                                  </tr>
                                  )}
                                  <tr>
                                    <th scope="row">SKU</th>
                                    <td>{product.sku || product.stock || 'N/A'}</td>
                                  </tr>
                                  <tr>
                                    <th scope="row">Price</th>
                                    <td>£{product.price ? parseFloat(product.price).toFixed(2) : '0.00'}</td>
                                  </tr>
                                  {product.product_discount && (
                                  <tr>
                                    <th scope="row">Discount</th>
                                    <td>{product.product_discount}%</td>
                                  </tr>
                                  )}
                                  <tr>
                                    <th scope="row">Stock Quantity</th>
                                    <td>{product.stock_quantity !== undefined ? product.stock_quantity : (product.stock || 'N/A')}</td>
                                  </tr>
                                  <tr>
                                    <th scope="row">Status</th>
                                    <td>
                                      <span className={`badge ${product.status === 'published' ? 'bg-success' : product.status === 'draft' ? 'bg-secondary' : 'bg-warning'}`}>
                                        {product.status || 'draft'}
                                      </span>
                                    </td>
                                  </tr>
                                  <tr>
                                    <th scope="row">Visibility</th>
                                    <td>{product.visibility || 'Public'}</td>
                                  </tr>
                                  {product.commission && (
                                  <tr>
                                    <th scope="row">Commission</th>
                                    <td>{product.commission}</td>
                                  </tr>
                                  )}
                                  {product.tax && (
                                  <tr>
                                    <th scope="row">Tax</th>
                                    <td>{product.tax}</td>
                                  </tr>
                                  )}
                                  {product.weight && (
                                  <tr>
                                    <th scope="row">Weight</th>
                                    <td>{product.weight} kg</td>
                                  </tr>
                                  )}
                                  {/* Parse attributes for material, dimensions, features */}
                                  {(() => {
                                    try {
                                      const attributes = typeof product.attributes === 'string' 
                                        ? JSON.parse(product.attributes || '{}') 
                                        : (product.attributes || {});
                                      const result = [];
                                      if (attributes.material) {
                                        result.push(
                                          <tr key="material">
                                            <th scope="row">Material</th>
                                            <td>{attributes.material}</td>
                                          </tr>
                                        );
                                      }
                                      if (attributes.dimensions) {
                                        const dim = attributes.dimensions;
                                        const dimensionsStr = [
                                          dim.length ? `${dim.length} cm (L)` : null,
                                          dim.width ? `${dim.width} cm (W)` : null,
                                          dim.height ? `${dim.height} cm (H)` : null
                                        ].filter(Boolean).join(' × ') || 'N/A';
                                        result.push(
                                          <tr key="dimensions">
                                            <th scope="row">Dimensions</th>
                                            <td>{dimensionsStr}</td>
                                          </tr>
                                        );
                                      }
                                      return result;
                                    } catch (e) {
                                      return null;
                                    }
                                  })()}
                                  {product.weight && (
                                  <tr>
                                    <th scope="row">Weight</th>
                                    <td>{product.weight} kg</td>
                                  </tr>
                                  )}
                                  {/* Parse attributes for material and dimensions */}
                                  {(() => {
                                    try {
                                      const attributes = typeof product.attributes === 'string' 
                                        ? JSON.parse(product.attributes || '{}') 
                                        : (product.attributes || {});
                                      const result = [];
                                      if (attributes.material) {
                                        result.push(
                                          <tr key="material">
                                            <th scope="row">Material</th>
                                            <td>{attributes.material}</td>
                                          </tr>
                                        );
                                      }
                                      if (attributes.dimensions) {
                                        const dim = attributes.dimensions;
                                        const dimensionsStr = [
                                          dim.length ? `${dim.length} cm (L)` : null,
                                          dim.width ? `${dim.width} cm (W)` : null,
                                          dim.height ? `${dim.height} cm (H)` : null
                                        ].filter(Boolean).join(' × ') || 'N/A';
                                        result.push(
                                          <tr key="dimensions">
                                            <th scope="row">Dimensions</th>
                                            <td>{dimensionsStr}</td>
                                          </tr>
                                        );
                                      }
                                      return result;
                                    } catch (e) {
                                      return null;
                                    }
                                  })()}
                                  {product.created_at && (
                                  <tr>
                                    <th scope="row">Created At</th>
                                    <td>{new Date(product.created_at).toLocaleString()}</td>
                                  </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </TabPane>
                          <TabPane
                            id="nav-detail"
                            tabId="2"
                          >
                            <div>
                              <h5 className="font-size-16 mb-3">
                                {product.name || 'Product Details'}
                              </h5>
                              {product.description ? (
                                <div dangerouslySetInnerHTML={{ __html: product.description }} />
                              ) : product.short_description ? (
                                <p>{product.short_description}</p>
                              ) : (
                                <p className="text-muted">No description available.</p>
                              )}
                              {product.product_tags && (
                                <div className="mt-3">
                                  <strong>Tags: </strong>
                                  <span className="text-muted">{product.product_tags}</span>
                                </div>
                              )}
                              {product.meta_keyword && (
                                <div className="mt-3">
                                  <strong>Meta Keywords: </strong>
                                  <span className="text-muted">{product.meta_keyword}</span>
                                </div>
                              )}
                              {product.meta_description && (
                                <div className="mt-3">
                                  <strong>Meta Description: </strong>
                                  <span className="text-muted">{product.meta_description}</span>
                                </div>
                              )}
                            </div>
                          </TabPane>
                        </TabContent>
                      </div>

                      <div className="mt-5">
                        <div>
                          <h5 className="fs-14 mb-3">Ratings & Reviews</h5>
                        </div>
                        <Row className="gy-4 gx-0">
                          <Col lg={4}>
                            <div>
                              <div className="pb-3">
                                <div className="bg-light px-3 py-2 rounded-2 mb-2">
                                  <div className="d-flex align-items-center">
                                    <div className="flex-grow-1">
                                      <div className="fs-16 align-middle text-warning">
                                        <i className="ri-star-fill"></i>{" "}
                                        <i className="ri-star-fill"></i>{" "}
                                        <i className="ri-star-fill"></i>{" "}
                                        <i className="ri-star-fill"></i>{" "}
                                        <i className="ri-star-half-fill"></i>
                                      </div>
                                    </div>
                                    <div className="flex-shrink-0">
                                      <h6 className="mb-0">4.5 out of 5</h6>
                                    </div>
                                  </div>
                                </div>
                                <div className="text-center">
                                  <div className="text-muted">
                                    Total{" "}
                                    <span className="fw-medium">5.50k</span>{" "}
                                    reviews
                                  </div>
                                </div>
                              </div>

                              <div className="mt-3">
                                <Row className="align-items-center g-2">
                                  <div className="col-auto">
                                    <div className="p-2">
                                      <h6 className="mb-0">5 star</h6>
                                    </div>
                                  </div>
                                  <div className="col">
                                    <div className="p-2">
                                      <div className="progress animated-progess progress-sm">
                                        <div
                                          className="progress-bar bg-success"
                                          role="progressbar"
                                          style={{ width: "50.16%" }}
                                          aria-valuenow="50.16"
                                          aria-valuemin="0"
                                          aria-valuemax="100"
                                        ></div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-auto">
                                    <div className="p-2">
                                      <h6 className="mb-0 text-muted">2758</h6>
                                    </div>
                                  </div>
                                </Row>

                                <Row className="align-items-center g-2">
                                  <div className="col-auto">
                                    <div className="p-2">
                                      <h6 className="mb-0">4 star</h6>
                                    </div>
                                  </div>
                                  <div className="col">
                                    <div className="p-2">
                                      <div className="progress animated-progess progress-sm">
                                        <div
                                          className="progress-bar bg-success"
                                          role="progressbar"
                                          style={{ width: "19.32%" }}
                                          aria-valuenow="19.32"
                                          aria-valuemin="0"
                                          aria-valuemax="100"
                                        ></div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-auto">
                                    <div className="p-2">
                                      <h6 className="mb-0 text-muted">1063</h6>
                                    </div>
                                  </div>
                                </Row>

                                <Row className="align-items-center g-2">
                                  <div className="col-auto">
                                    <div className="p-2">
                                      <h6 className="mb-0">3 star</h6>
                                    </div>
                                  </div>
                                  <div className="col">
                                    <div className="p-2">
                                      <div className="progress animated-progess progress-sm">
                                        <div
                                          className="progress-bar bg-success"
                                          role="progressbar"
                                          style={{ width: "18.12%" }}
                                          aria-valuenow="18.12"
                                          aria-valuemin="0"
                                          aria-valuemax="100"
                                        ></div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-auto">
                                    <div className="p-2">
                                      <h6 className="mb-0 text-muted">997</h6>
                                    </div>
                                  </div>
                                </Row>

                                <Row className="align-items-center g-2">
                                  <div className="col-auto">
                                    <div className="p-2">
                                      <h6 className="mb-0">2 star</h6>
                                    </div>
                                  </div>
                                  <div className="col">
                                    <div className="p-2">
                                      <div className="progress animated-progess progress-sm">
                                        <div
                                          className="progress-bar bg-warning"
                                          role="progressbar"
                                          style={{ width: "7.42%" }}
                                          aria-valuenow="7.42"
                                          aria-valuemin="0"
                                          aria-valuemax="100"
                                        ></div>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-auto">
                                    <div className="p-2">
                                      <h6 className="mb-0 text-muted">408</h6>
                                    </div>
                                  </div>
                                </Row>

                                <Row className="align-items-center g-2">
                                  <div className="col-auto">
                                    <div className="p-2">
                                      <h6 className="mb-0">1 star</h6>
                                    </div>
                                  </div>
                                  <div className="col">
                                    <div className="p-2">
                                      <div className="progress animated-progess progress-sm">
                                        <div
                                          className="progress-bar bg-danger"
                                          role="progressbar"
                                          style={{ width: "4.98%" }}
                                          aria-valuenow="4.98"
                                          aria-valuemin="0"
                                          aria-valuemax="100"
                                        ></div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-auto">
                                    <div className="p-2">
                                      <h6 className="mb-0 text-muted">274</h6>
                                    </div>
                                  </div>
                                </Row>
                              </div>
                            </div>
                          </Col>

                          <Col lg={8}>
                            <div className="ps-lg-4">
                              <div className="d-flex flex-wrap align-items-start gap-3">
                                <h5 className="fs-14">Reviews: </h5>
                              </div>

                              <SimpleBar
                                className="me-lg-n3 pe-lg-4"
                                style={{ maxHeight: "225px" }}
                              >
                                <ul className="list-unstyled mb-0">
                                  {reviews.map((review, key) => (
                                    <React.Fragment key={key}>
                                      <ProductReview review={review} />
                                    </React.Fragment>
                                  ))}
                                </ul>
                              </SimpleBar>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default EcommerceProductDetail;